<template>
  <div>
    <base-header class="pb-6 pb-8 pt-5 pt-md-6 bg-gradient-success">
      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <h3 class="card-title"><b-button size="sm" v-b-toggle.accordion-1 variant="info"><i class="fa fa-filter"></i></b-button>Filtros </h3>
            
          </b-card-header>
          <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <!--b-card-text>I start opened because <code>visible</code> is <code>true</code></b-card-text>
              <b-card-text>{{ text }}</b-card-text>-->
              <b-row>
                <b-col sm="3">
                    <b-input-group size="sm" prepend="Nro Caja">
                      <b-form-input size="sm" id="idCaja" type="text" v-on:change="onFiltroChange" v-model="filtro.idCaja" value="" placeholder="000"></b-form-input>
                    </b-input-group>                                   
                    <!--<select name="idTurno" v-on:change="onFiltroChange" v-model="filtro.idTurno" id="idTurno" class="form-control form-control-sm" :class="{ 'is-invalid': filtro.errors.has('idTurno') }">
                        <option value="-1">Seleccione Turno</option>
                        <option v-for="itemc in turnos" :value="itemc.id"  v-bind:key="itemc.id">
                            {{itemc.descripcion}}
                        </option>                                  
                    </select>-->
                </b-col>
                <b-col sm="3">
                    <b-input-group size="sm" prepend="NroTurno">
                      <b-form-input size="sm" id="idTurno" type="text" v-on:change="onFiltroChange" v-model="filtro.idTurno" value="" placeholder="000"></b-form-input>
                    </b-input-group>                    
                    <!--<select name="estado" v-on:change="onFiltroChange" v-model="filtro.estado" id="estado" class="form-control form-control-sm" :class="{ 'is-invalid': filtro.errors.has('estado') }">
                        <option value="">Seleccione Region</option>
                        <option v-for="itemc in selectEdo" :value="itemc.id"  v-bind:key="itemc.id">
                            {{itemc.nombre}}
                        </option>                                  
                    </select>-->                     
                </b-col>
                <b-col sm="3">
                    <b-form-input size="sm" id="nombreUser" type="text" v-on:change="onFiltroChange" v-model="filtro.nombreCajera" name="nombreCajera" placeholder="Nombre Cajera"></b-form-input>
                </b-col>
                <b-col sm="3" class="text-center">
                        <b-button title="Aplicar filtro" :class="{'btn btn-success' :filtroActivo, 'btn btn-light':!filtroActivo}" @click="aplicarFiltro()"><i :class="{'fas fa-check':filtroActivo,'fas fa-ban':!filtroActivo}"></i></b-button>
                        <b-button title="Resetear filtro" variant="primary" @click="resetFiltro()"><i class="fas fa-undo"></i></b-button>
                </b-col>
              </b-row>
              <b-row>
                  <b-col sm="3">
                    <b-form-input class="form-control form-control-sm float-right" id="fechaI" type="date" v-on:change="onFiltroChange" v-model="filtro.fechaI" name="fechaI" min="01-01-2000"
              max="31-12-3000"></b-form-input>
                  </b-col>
                  <b-col sm="3">
                    <select name="formaPagoId" v-on:change="onFiltroChange" v-model="filtro.formaPagoId" id="formaPagoId" class="form-control form-control-sm" :class="{ 'is-invalid': filtro.errors.has('formaPagoId') }">
                        <option value="0">Todos Formas de Pago</option>
                        <option v-for="itemc in formasPago" :value="itemc.descripcion"  v-bind:key="itemc.id">
                            {{itemc.descripcion}}
                        </option>
                    </select>
                  </b-col>
                  <b-col sm="3">
                    <select name="diferencia" v-on:change="onFiltroChange" v-model="filtro.diferencia" id="diferencia" class="form-control form-control-sm" :class="{ 'is-invalid': filtro.errors.has('diferencia') }">
                        <option value="">Seleccione Diferencia</option>
                        <option value="0">Sin Diferencia</option>                        
                        <option value="1">Sobrante</option>
                        <option value="-1">Faltante</option>
                    </select>
                  </b-col>                                                                       
              </b-row>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
      <!-- Card stats -->
      <!--<b-row>
        <b-col xl="3" md="6">
          <stats-card title="Total traffic"
                      type="gradient-red"
                      sub-title="350,897"
                      icon="ni ni-active-40"
                      class="mb-4">

            <template slot="footer">
              <span class="text-success mr-2">3.48%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card title="Total traffic"
                      type="gradient-orange"
                      sub-title="2,356"
                      icon="ni ni-chart-pie-35"
                      class="mb-4">

            <template slot="footer">
              <span class="text-success mr-2">12.18%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
        <b-col xl="3" md="6">
          <stats-card title="Sales"
                      type="gradient-green"
                      sub-title="924"
                      icon="ni ni-money-coins"
                      class="mb-4">

            <template slot="footer">
              <span class="text-danger mr-2">5.72%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>

        </b-col>
        <b-col xl="3" md="6">
          <stats-card title="Performance"
                      type="gradient-info"
                      sub-title="49,65%"
                      icon="ni ni-chart-bar-32"
                      class="mb-4">

            <template slot="footer">
              <span class="text-success mr-2">54.8%</span>
              <span class="text-nowrap">Since last month</span>
            </template>
          </stats-card>
        </b-col>
      </b-row>-->
    </base-header>
    <b-container fluid class="mt--7">
      <b-row>
        <b-col>
        <b-card no-body>
            <b-card-header class="border-0">
                <h3 class="mb-0">Reporte Cuadre Caja</h3>
            </b-card-header>
            <div class="card-body table-responsive p-0">
                    <table class="table table-hover text-center">
                      <tbody>
                        <tr class="thead-light">                            
                            <th>Caja</th>                            
                            <th>Cajer@</th>
                            <th>Turno</th>
                            <th>Forma Pago</th>
                            <th>Recaudado</th>
                            <th>Declarado</th>
                            <th>Diferencia</th>
                            <th>---</th>                            
                            <th>Acciones</th>
                      </tr>
                      <tr v-for="lstFaltSob in listadoFaltSobr" :key="lstFaltSob.id">                        
                        <td>{{lstFaltSob.caja}}</td>                    
                        <td>{{lstFaltSob.cajera}}</td>
                        <td>{{lstFaltSob.turno}}</td>
                        <td>{{lstFaltSob.descripcion}}</td>
                        <td class="text-right">{{lstFaltSob.procesado | moneda}}</td>
                        <td class="text-right">{{lstFaltSob.declarado | moneda}}</td>
                        <td class="text-right">{{lstFaltSob.diferencia | moneda}}</td>                        
                        <td>{{descripFaltSob(lstFaltSob)}}</td>
                        <td>
                            <!--<base-button size="sm" type="secondary" title="Ver lstFaltSob" 
                            @click="verDetallelstFaltSob(lstFaltSob)"
                            :class="{'disabled':(lstFaltSob.estatus == -1 || lstFaltSob.estatus == 0)}">
                                <i class="fa fa-tasks"></i>
                            </base-button>  -->                      
                            <base-button size="sm" type="warning" @click="editModal(lstFaltSob)">
                                <i class="fa fa-edit"></i>
                            </base-button>                        
                            <base-button size="sm" type="secondary" 
                              v-b-popover.hover.top="'Ver Turno'"
                              @click="verTurnos(lstFaltSob)"

                              >
                             <i class="fas fa-directions"></i>
                            </base-button>
                            <base-button size="sm" type="secondary" 
                              v-b-popover.hover.top="'Ver Facturas'"
                              @click="desgloseFactura(lstFaltSob)"

                              >
                              <i class="fa fa-eye"></i>
                            </base-button>                              
                        </td>
                      </tr>
                    </tbody></table>
                <!-- /.card -->
            </div>
            <b-card-footer class="py-4 d-flex justify-content-end">
                <base-pagination @change="getResults" v-model="currentPage" :per-page="perPage" :total="totalItemsRow"></base-pagination>
            </b-card-footer>
        </b-card>          
          <!--<light-table/>          
          <dark-table/>-->
        </b-col>
      </b-row>
      <div class="mt-5"></div>     
    </b-container>


  </div>
</template>
<script>
  import { Dropdown, DropdownItem, DropdownMenu, Table, TableColumn } from 'element-ui';
  export default {
    components: {
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },
    data() {
      return {
      editmode: false,
      filtroActivo:false,
      perPage:10,
      currentPage: 1,
      totalItemsRow:10,      
      cajero:{
          accionesAdc: null,
          apellido: "",
          cedula: "",
          createdAt: "",
          estatus: 1,
          id: 1,
          nick: "",
          nombre: "",
          password: "",
          rolId: 0,
          sucursal: 0,
          tipo: 0,
          updatedAt: "",         
      },
      monedaSelect:1,
      tipoMoneda:[{id:1, detalle:'Bs.'},{id:2, detalle:'$'}],//1:Bolivar, 2:Dolar
      listadoFaltSobr:[],
      formasPago:[],
      facturaActual:{},
      productoActual:{},
      filtro: new Form({
        idTurno: 0,
        idCaja: 0,
        diferencia:"",
        fechaI: this.getDate(),
        fechaF: this.getDate(),
        IdUsuario:0,
        formaPagoId: 0,
        nombreCajera: '',
      }),
      };
      
    },
    methods: {
      async getResults(page = 1) {      
        await axios.get(this.$gate.getApiUrl()+'CajaAdministrativa/ReporteFaltantesSobrantes?page='+page+'&perPage='+this.perPage,{ params: this.filtro })
        .then(({ data }) => {
          this.listadoFaltSobr = data.data.facturas;
          this.totalItemsRow = data.data.totalrow;
        }).catch( e => {
            /* si el token es invalido o esta vencido */
            if (e.response.status == 401) {
               this.$gate.removeLogin();
               this.$router.push("/Login");             
            }
        });
      },
      verTurnos(fs){  
        this.$router.push("turnos?fecha="+this.filtro.fechaI+"&Caja="+fs.caja);
      },      
      desgloseFactura(fs){  
        this.$router.push("factura/desglose?fecha="+this.filtro.fechaI+"&turno="+fs.turno+"&caja="+fs.caja);
      },           
      editModal(caja){
        this.editmode = true;
        this.form.reset();
        this.$refs['modal-1'].show();
        //$('#addNew').modal('show');
        this.form.fill(caja);
      },
      aplicarFiltro(){
        //if(this.$gate.isAdmin()){
          let loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: true,
            loader: 'dots',
          });
          this.getResults();
          loader.hide();     
      },       
      resetFiltro(){
        this.filtro.reset();      
        this.filtroActivo = false;
        this.getResults();
      },      
      onFiltroChange(){
        this.filtroActivo = true;
        if(!this.filtro.idTurno){
          this.filtro.idTurno = 0;
        }
      },
      descripFaltSob(lstFaltSob){
        return (Math.round(lstFaltSob.diferencia)==0 || Math.round(lstFaltSob.diferencia)==-0)?"CUADRA":(Math.round(lstFaltSob.diferencia) < 0)?"FALTANTE":"SOBRANTE";
      },
      hideModal() {
        this.$refs['modal-1'].hide();
      },
      getHora(){
        var currentDate = new Date();
        var hora = currentDate.getHours();
        var min = currentDate.getMinutes();
        //var seg = currentDate.getSeconds();
        return (hora<10?("0"+hora):hora)+":"+(min<10?("0"+min):min);
      },
      getDate(){
        var currentDate = new Date();        
        return currentDate.getFullYear()+"-"+(currentDate.getMonth()<9?"0"+(currentDate.getMonth()+1):(currentDate.getMonth()+1))+"-"+(currentDate.getDate()<10?"0"+currentDate.getDate():currentDate.getDate());
      },      
      loadResumen(){
        /*if (this.$route.query.hasOwnProperty('turno') && this.$route.query.hasOwnProperty('caja')) {
          this.filtro.turno = this.$route.query.turno;
          this.filtro.codigoCaja = this.$route.query.caja;
        }
        if(this.$route.query.hasOwnProperty('fecha')){
            this.filtro.fecha = this.$route.query.fecha;
        }*/
        this.getResults();      
        axios.get(this.$gate.getApiUrl()+"FormaPago").then(({ data }) => {this.formasPago = data; console.log(this.formasPago) });
      },

    },
    computed: {

    },    
    created(){
      this.loadResumen();
    }
  };
</script>
<style>
 .statscard{
   font-size: 13px;
 }
 .fondotasa{
   background: #f5f5f5;   
   font-weight: bold;
 } 
 .detallefactura {
    font-size: 0.8125rem;
    white-space: nowrap;
 }
 .bckgmontobs{
   background: #e2e6e7;
   font-weight: bold;
 }  
</style>